import constants from '~/code/config/constants'
import { Config } from '~/code/models'

export default {
    authUrl: constants.localAuthUrl,
    paymentPageUrl: constants.localPaymentPageUrl,
    apiUrl: constants.localApiUrl
} as Config
